<template>
  <div>
    <van-form @submit="onSubmit">
      <van-field
          v-model="jumpUrl"
          name="jumpUrl"
          label="跳转页面"
          placeholder="请输入页面地址"/>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">跳转</van-button>
      </div>
    </van-form>
    <div style="margin: 16px;">
      <van-button round block type="info" @click="clearSession">清除缓存</van-button>
    </div>
    <van-field name="switch" label="是否开启调试开关" label-width="120">
      <template #input>
        <van-switch v-model="switchChecked" size="20" @change="switchChange"/>
      </template>
    </van-field>
  </div>
</template>

<script>
import Vconsole from 'vconsole'
import {Button, Field, Form, Switch} from 'vant'

export default {
  name: 'BrandBin',
  data() {
    return {
      jumpUrl: '',
      switchChecked: false
    }
  },
  components: {
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Switch.name]: Switch
  },
  methods: {
    onSubmit(form) {
      this.$router.push(form.jumpUrl)
    },
    switchChange(boolean) {
      if (boolean) {
        new Vconsole()
      }
    },
    clearSession() {
      sessionStorage.clear()
    }
  }
}
</script>

<style scoped>

</style>